// extracted by mini-css-extract-plugin
module.exports = {"darkText":"#333","green":"#006338","progress":"MediaProgress_progress__CU-rZ"};